import { FC } from "react";
import RoleTableRow from "./RoleTableRow";
import { enumToSelectProps } from "../../../tools/EnumTools";
import { useTranslation } from "react-i18next";
import { Role } from "../../../domain/models/Role";
import { RoleDTO } from "../../../domain/models/dto/RoleDTO";
import { RoleFields } from "../../../domain/enums/RoleFieldsEnum";
import AddRowsSVG from "../../../components/shared/svg/AddRowsSVG";

interface RolesTableProps {
    roles: Role[];
    updateHandler: (role: RoleDTO) => void;
}

const RolesTable: FC<RolesTableProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="w-[95%] h-[calc(100vh-150px)] ml-auto mr-auto relative bg-light-bg-700 dark:bg-dark-bg-800 overflow-auto shadow-md rounded-xl">
            <table className="w-full text-sm text-left text-light-text-100 dark:text-dark-text-100">
                <thead className="sticky top-0 text-[14px] font-extralight leading-[16px] text-light-text-100 dark:text-dark-text-100 bg-light-bg-800 dark:bg-dark-bg-900">
                    <tr className="text-center px-2 py-3 group relative">
                        {Object.values(enumToSelectProps(RoleFields, "console.roles.table")).map((value) => (
                            <th
                                key={`th-roles-table-${value.labelKey}`}
                                className="px-2 py-3 group border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900"
                            >
                                {t(value.labelKey)}
                            </th>
                        ))}
                        <th className="px-2 py-3 group border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900">
                            {t("console.roles.table.add")}
                        </th>
                        {/* <th className="px-2 py-3 border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900">
                            <button
                                className="flex items-center justify-center w-[28px] h-[28px] mx-auto"
                                title="Редагувати"
                            >
                                <AddRowsSVG className="w-[25px] h-[25px] fill-light-fill-100 dark:fill-dark-fill-100" />
                            </button>
                        </th> */}
                    </tr>
                </thead>
                <tbody>
                    {props.roles.map((role) => (
                        <RoleTableRow
                            key={`tr-role-table-${role.id}`}
                            role={role}
                            updateHandler={props.updateHandler}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RolesTable;
